import { FC } from 'react'
import style from './style.m.less'
import { Link } from 'react-router-dom'
import { LogoGreenETrack } from '../../../../assets/icons'
import { useTranslation } from 'react-i18next'

export const externalRoutes = [
    { id: 1, href: 'https://www.np-sr.ru/ru', title: 'header.npLabel' },
    { id: 2, href: 'https://www.atsenergo.ru/', title: 'header.atsLabel' },
    { id: 3, href: 'https://cfrenergo.ru/', title: 'header.cfrLabel' },
    { id: 4, href: 'https://www.ec-mc.ru/', title: 'header.educationLabel' },
    { id: 5, href: 'https://green-e-track.ru/', title: 'header.greenLabel', isGreen: true },
]

export const TelegramIcon: FC = () => (
    <svg width="13.5" viewBox="0 0 625 518" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M43.2773 222.931C210.901 149.9 322.677 101.753 378.604 78.4909C538.288 12.0729 571.469 0.535428 593.096 0.154453C597.852 0.0706614 608.488 1.24949 615.377 6.8396C621.194 11.5598 622.795 17.9361 623.561 22.4113C624.326 26.8866 625.28 37.0813 624.522 45.0472C615.869 135.968 578.426 356.61 559.377 458.443C551.317 501.532 535.446 515.98 520.081 517.394C486.69 520.467 461.334 495.327 428.993 474.127C378.386 440.953 349.796 420.302 300.672 387.93C243.902 350.519 280.704 329.958 313.057 296.354C321.524 287.56 468.647 153.74 471.495 141.601C471.851 140.083 472.181 134.423 468.819 131.435C465.457 128.447 460.495 129.468 456.914 130.281C451.838 131.433 370.992 184.869 214.376 290.59C191.428 306.348 170.642 314.025 152.019 313.623C131.489 313.18 91.9963 302.015 62.6378 292.472C26.6283 280.766 -1.99123 274.578 0.500888 254.699C1.79894 244.344 16.0577 233.755 43.2773 222.931Z"
            fill="white"
        />
    </svg>
)

const ExternalNavigation: FC = () => {
    const { t } = useTranslation()
    return (
        <div className={style.background}>
            <div className={style.container}>
                <Link to="main" className={style.link}>
                    <LogoGreenETrack />
                </Link>
                <div className={style.subContainer}>
                    {externalRoutes.map((route) => (
                        <a
                            key={route.id}
                            href={route.href}
                            target="_blank"
                            className={route.isGreen ? style.green : undefined}
                            rel="noreferrer"
                        >
                            {t(route.title)}
                        </a>
                    ))}
                    <a
                        href="https://t.me/green_e_track"
                        target="_blank"
                        className={style.telegramButton}
                        rel="noreferrer"
                    >
                        <TelegramIcon />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default ExternalNavigation
